import { nodeExerciseRoute, isTopicDrillNode } from "@music-app/learning-system";

/**
 * Practice link for a lesson's node — the "Practice this" affordance on the
 * Learn hub and each lesson page. Resolves the node to its drill via the shared
 * `nodeExerciseRoute` source of truth (never a page-local `EXERCISE_SKILL_NODES`
 * copy), opening in Listen mode with the node carried through so the drill lands
 * on its Listen config for that skill. Returns undefined when a node has no
 * exercise skill, so callers render no Practice affordance.
 */
export function lessonPracticeRoute(nodeId: string): string | undefined {
  if (isTopicDrillNode(nodeId)) {
    return `/exercise/topic/${nodeId}?mode=listen&from=learn`;
  }
  const route = nodeExerciseRoute(nodeId);
  if (!route) return undefined;
  return `${route.path}?mode=listen&nodeId=${nodeId}&from=learn`;
}
